module.exports = __webpack_public_path__ + "static/media/bucket.f2e7a5b6.svg";